
















































































































import { Component, Vue } from 'vue-property-decorator';
import * as grpcWeb from 'grpc-web';

import NewGameForm from '@/components/NewGameForm.vue';
import {RegisterRequest, NewGameRequest, ListGamesRequest,
        Game as PBGame, GameStatus} from '@/proto/banana_pb';

interface Game {
  id: string;
  name: string;
  playerCount: number;
  stat: GameStatus;
}

@Component({
  components: {
    NewGameForm,
  },
})
export default class Home extends Vue {
  private games: Game[] = [];

  private showModal = false;
  private playerName: string = '';

  private mounted(): void {
    const playerName = this.$cookies.get('player-name');
    if (playerName) {
      this.playerName = playerName;
      this.loadGames();
    } else {
      // Have them set their name.
      this.showModal = true;
    }

  }

  private registerPlayer(): void {
    if (!this.playerName) {
      // If they didn't set a name, just leave the dialog open.
      return;
    }
    const req = new RegisterRequest();
    req.setName(this.playerName);
    this.$client.register(req, {}, (err, resp) => {
      if (err) {
        console.log(err);
        return;
      }
      this.showModal = false;
      this.$cookies.set('player-name', this.playerName);
      this.$cookies.set('player-id', resp.getPlayerId());
      this.$cookies.set('player-token', resp.getToken());
      this.loadGames();
    });
  }

  private changeName(): void {
    this.showModal = true;
  }

  private joinGame(id: string): void {
    const playerName = this.playerNameFromCookies();
    if (playerName) {
      this.$router.push({ name: 'game', params: { id } });
      return;
    }

    // Show a login modal.
    this.showModal = true;
  }

  private spectate(id: string): void {
    this.$router.push({ name: 'spectate', params: { id } });
  }

  private playerNameFromCookies(): string | undefined {
    return this.$cookies.get('player-name');
  }

  private loadGames() {
    const stream = this.$client.streamGames(new ListGamesRequest(), {});

    stream.on('data', (resp) => {
      const indexMap: { [s: string]: number; } = {};
      let i = 0;
      for (const game of this.games) {
        indexMap[game.id] = i;
        i++;
      }

      const gameUpdates = resp.getGamesList();
      for (const game of gameUpdates) {
        // Game already exists, update it.
        if (indexMap.hasOwnProperty(game.getId())) {
          Vue.set(this.games, indexMap[game.getId()], this.toGame(game));
          continue;
        }

        // Game doesn't exist yet, add it.
        this.games.push(this.toGame(game));
      }
    });
    stream.on('error', (err: grpcWeb.Error) => {
      this.$emit('rpcError', err);
    });
  }

  private gameStatus(stat: GameStatus): string {
    switch (stat) {
      case GameStatus.WAITING_FOR_PLAYERS:
        return 'Waiting for players';
      case GameStatus.IN_PROGRESS:
        return 'In progress';
      case GameStatus.FINISHED:
        return 'Finished';
      default:
        return 'Unknown';
    }
  }

  private toGame(g: PBGame): Game {
    return {
      id: g.getId(),
      name: g.getName(),
      playerCount: g.getPlayerCount(),
      stat: g.getStatus(),
    };
  }
}
